import { render, staticRenderFns } from "./RightBox.vue?vue&type=template&id=ee4064a2&scoped=true&lang=pug&"
import script from "./RightBox.vue?vue&type=script&lang=coffee&"
export * from "./RightBox.vue?vue&type=script&lang=coffee&"
import style0 from "./RightBox.vue?vue&type=style&index=0&id=ee4064a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4064a2",
  null
  
)

export default component.exports